export default __webpack_public_path__ + "static/media/Rejected.a43ce8af.svg";